<template>
	<div id="personalNav">
		<div class="personal_nav">
			<div class="personal_nav_left">
				<img src="../../public/img/51head.png" alt="">
			</div>
			<div class="personal_nav_right">
				<div class="personal_nav_right_item" v-for="(item, index) in navData" @click="routerLink(index)" :key="index">
					<span v-if="index == 2">
            <router-link :to="{path:item.src,query:{}}" class="personal_nav_right_item_txt" v-if="sign == 1 || sign == 2">
              {{item.name}}
            </router-link>
          </span>
					<span v-else>
            <router-link :to="{path:item.src,query:{}}" class="personal_nav_right_item_txt">
              {{item.name}}
            </router-link>
          </span>
					<div :class="navIndex == index ? 'personal_nav_right_item_btn' : ''"></div>
					<!--<div v-if="index == 2 && sign == 1 || index == 2 && sign == 2" class="nav_number">{{daishenNum}}</div>-->
					<div v-if="index == 1" class="nav_hover">
						<div class="nav_hover_item">
							<div class="nav_hover_item_head">
								个人资料
							</div>
							<div class="nav_hover_item_content">
								<router-link to="/personalaccount" class="nav_hover_item_contents">基本信息</router-link>
							</div>
							<div class="nav_hover_item_content">
								<router-link to="/personalAddress" class="nav_hover_item_contents">收货地址</router-link>
							</div>
						</div>
						<div class="nav_hover_item">
							<div class="nav_hover_item_head">
								安全设置
							</div>
							<div class="nav_hover_item_content">
								<router-link to="/personalXg" class="nav_hover_item_contents">修改密码</router-link>
							</div>
							<div class="nav_hover_item_content">
								<router-link to="/personalPhone" class="nav_hover_item_contents">手机绑定</router-link>
							</div>
						</div>
						<div class="nav_hover_item">
							<div class="nav_hover_item_head">
								账号绑定
							</div>
							<div class="nav_hover_item_content">
								<router-link to="/personalWechart" class="nav_hover_item_contents">微信绑定</router-link>
							</div>
							<div class="nav_hover_item_content">
								<router-link to="/personalEmail" class="nav_hover_item_contents">邮箱绑定</router-link>
							</div>
						</div>
						<div class="nav_hover_item" v-if="sign == 1 || sign == 2">
							<div class="nav_hover_item_head">
								集团账号管理
							</div>
							<div class="nav_hover_item_content" v-if="sign == 1">
								<router-link to="/personalCgr" class="nav_hover_item_contents">采购员管理</router-link>
							</div>
							<div class="nav_hover_item_content">
								<router-link to="/personalProcurement" class="nav_hover_item_contents">采购订单</router-link>
							</div>
						</div>
					</div>
				</div>

			</div>
			<div class="personal_nav_footer">
				<router-link to="/index" class="personal_nav_footer_item_txt">
					返回商城首页
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
	import qs from "qs";
	export default {
		data() {
			return {
				navIndex: 0,
				navData: [{
					name: '会员主页',
					src: '/personalHome'
				}, {
					name: '账户管理',
					src: '/personalaccount'
				}, {
					name: '采购审批',
					src: '/personalProcurement'
				}],
				sign: '',
				daishenNum: 0,
				dingdanData: {}, //审核列表所需参数
			}
		},
		created() {
			let that = this;
			//			that.ScrollUp();

			if(that.$storage.get('user_data') != null) {
				that.sign = that.$storage.get('user_data').sign
				if(that.sign == 1) {
					that.dingdanData['company_id'] = that.$storage.get('user_data').company_id;
				}
				that.dingdanData['user_id'] = that.$storage.get('user_data').user_id;
				that.huoquDingdans();
			} else {

			}
		},
		mounted() {

			window.addEventListener('scroll', this.handleScroll)
		},
		methods: {
			routerLink(index) {
				// 点击哪个路由就赋值给自定义的下下标
				this.navIndex = index;
				// 路由跳转
			},
			huoquDingdans(page = 1) {
				let that = this;

				axios({
						method: 'post',
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
						},
						url: that.$publicUrl.http1 + that.$publicUrl.purchaselists,
						data: qs.stringify({
							user_id: that.dingdanData['user_id'],
							company_id: that.dingdanData['company_id'],
							page: page,

						}),

					})
					.then(function(response) {
						//						console.log(response);
						let data = response.data;
						if(data.stateCode == 10000) {
							that.daishenNum = data.data.total; //公告列表
						
						} else {

						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
		},

	}
</script>

<style scoped>
	#personalNav {
		width: 100%;
		height: 60px;
		background-color: #dc1e33;
	}
	
	.personal_nav {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		flex-wrap: nowrap;
	}
	
	.personal_nav_left {
		width: 220px;
		text-align: center;
		font-size: 36px;
		/*line-height: 60px;*/
		color: #fff;
		font-weight: 400;
	}
	
	.personal_nav_right {
		display: flex;
		flex-wrap: nowrap;
		width: 730px;
	}
	
	.personal_nav_right_item {
		width: 160px;
		height: 60px;
		line-height: 60px;
		text-align: center;
		position: relative;
		cursor: pointer;
	}
	
	.personal_nav_right_item_txt {
		font-size: 20px;
		color: #ffffff;
		font-weight: 400;
	}
	
	.personal_nav_right_item_btn {
		display: block;
		/*margin: 20px auto;*/
		width: 0;
		height: 0;
		border: 10px solid transparent;
		border-bottom-color: white;
		position: absolute;
		bottom: 0;
		left: calc((100% - 20px) / 2);
	}
	
	.personal_nav_right_item_btn_style {
		display: none;
	}
	
	.personal_nav_footer {
		width: calc(100% - 220px - 730px);
		height: 60px;
		line-height: 60px;
		text-align: right;
	}
	
	.personal_nav_footer_item_txt {
		font-size: 18px;
		color: #ffffff;
		font-weight: 400;
		text-decoration: underline
	}
	
	.nav_number {
		position: absolute;
		right: 16px;
		top: 5px;
		background: #fff;
		color: #DC1E33;
		font-size: 16px;
		border-radius: 50%;
		text-align: center;
		line-height: 20px;
		padding: 1.6px;
	}
	
	.nav_hover {
		width: 470px;
		height: 165px;
		background: #ffffff;
		position: absolute;
		bottom: -165px;
		left: calc((470px - 160px) / 2 * -1);
		box-shadow: 0 1px 6px #cccccc;
		display: none;
		flex-wrap: nowrap;
		justify-content: space-around;
		z-index: 1000;
		padding-left: 10px;
		padding-right: 10px;
		box-sizing: border-box;
	}
	
	.personal_nav_right_item:hover .nav_hover {
		display: flex;
	}
	
	.nav_hover_item {
		width: 110px;
		line-height: 30px;
		text-align: left;
	}
	
	.nav_hover_item_head {
		font-size: 18px;
		color: #333333;
		margin-bottom: 20px;
		margin-top: 20px;
	}
	
	.nav_hover_item_content {
		font-size: 16px;
		color: #333333;
		margin-bottom: 5px;
	}
	
	.nav_hover_item_contents:hover {
		color: #D81023;
	}
</style>